import { query, mutate } from '../graphql/apollo';
import { API_KEY } from '../utils/const';
import BaseApi from './base-api';

class AppApi extends BaseApi {

  getPersonalAccidentInsuranceAllProduct({
    langId,
    dob,
    insuranceAmount,
    type,
  }) {
    const data = {
      langId,
      dob,
      insuranceAmount,
      type,
      apiKey: API_KEY,
    };

    const outputSchema = `
    query getPersonalAccidentInsuranceAllProduct(
      $langId: String!
      $dob: String!
      $insuranceAmount: Int
      $type: Int
      $apiKey: String!){
      getPersonalAccidentInsuranceAllProduct(
        langId: $langId,
        dob: $dob,
        insuranceAmount: $insuranceAmount,
        type: $type,
        apiKey: $apiKey
      ){
        companies{
          code
          image
          name
        }
        products{
          productCode
          advanceCash
          benefits{
            id
            code
            sumAssured {
              id
            }
          }
          benefitsDescription
          billingType
          claimDocs
          company{
            id
            code
            name
            description
            image
          }
          description
          descriptionDetail
          discountRate
          effectiveDate
          insuredDeclaredValue
          name
          planId
          planDescription
          planName
          productId
          sellingPoint
          totalAllPremium
          totalAllSumAssured
          type
          zeroDepClaims
          eligibility {
            min_age
            max_age
          }
        }
      }
    }`
    return query(outputSchema, data);
  }

  getMotobikeInsuranceAllProduct({ langId, type, yearType }) {
    const data = {
      langId,
      type,
      apiKey: API_KEY,
      yearType: yearType || 1
    };
    const outputSchema = `
    query getMotobikeInsuranceAllProduct($langId: String!, $type: Int, $apiKey: String!, $yearType: Int) {
      getMotobikeInsuranceAllProduct(
        langId: $langId
        type: $type
        apiKey: $apiKey
        yearType: $yearType
      )  {
        products {
          productCode
          advanceCash
          benefits {
            benefitCode
            id
            code
            sumAssured {
              id
            }
          }
          benefitsDescription
          billingType
          claimDocs
          company{
            code
            description
            id
            image
            name
          }
          description
          descriptionDetail
          discountRate
          effectiveDate
          insuredDeclaredValue
          name
          planId
          productId
          sellingPoint
          totalAllPremium
          premium
          totalAllSumAssured
          type
          zeroDepClaims
        }
      }
    }
    `
    return query(outputSchema, data)
  }

  getHomeInsuranceAllProduct({ langId, type }) {
    const data = {
      langId,
      type,
      apiKey: API_KEY,
    };
    const outputSchema = `
    query getHomeInsuranceAllProduct($langId: String!, $type: Int, $apiKey: String!) {
      getHomeInsuranceAllProduct(
        langId: $langId
        type: $type
        apiKey: $apiKey
      )  {
        products {
          id
          productCode
          advanceCash
          benefits {
            apply_type
            apply_unit
            benefitCode
            sumInsured
            childBenefits {
              code
              name
              sumInsured
            }
            data
            description
            id
            isActive
            isDelete
            level
            max_sum_assured
            min_sum_assured
            name
            parentId
            requiredBenefit
            rate {
              id
              benefit_id
              premiumRule {
                id
                premium_formula
                age_max
                age_min
              }
              vat
            }
          }
          benefitsDescription
          billingType
          claimDocs
          company{
            code
            description
            id
            image
            name
          }
          description
          descriptionDetail
          discountRate
          effectiveDate
          insuredDeclaredValue
          name
          planId
          productId
          sellingPoint
          totalAllPremium
          totalAllSumAssured
          type
          zeroDepClaims
        }
      }
    }
    `
    return query(outputSchema, data)
  }

  getCarInsuranceAllProduct({
    langId,
    type,
    seat,
    goodsCap,
    carInfo,
    usePurpose,
  }) {
    const data = {
      langId, type,
      apiKey: API_KEY,
      car: {
        usePurpose,
        brand: "HX1",
        model: "HX1-DX7",
        firstRegistrationYear: 2017, seat,
        licensePlate: "72A-004.88",
        currency: "VND",
        carInfo
      }
    };
    if (goodsCap) {
      data.car.goodsCap = goodsCap
      // data.car.seat = 0
    }
    const outputSchema = `
    query getBasicCarInsuranceFeeOfAllProducts($langId: String!, $type: String!, $apiKey: String!, $car: CarInfo!) {
      getBasicCarInsuranceFeeOfAllProducts(langId: $langId, type: $type, apiKey: $apiKey, car: $car) {
        products {
          id
          productId
          productCode
          company {
            id
            code
            name
            address
            phoneNumber
            image
          }
          discountRate
          name
          effectiveDate
          policyTerm
          description
          type
          image
          premium
          insuredDeclaredValue
          cashlessGarage
          listBenefit
          advanceCash
          zeroDepClaims
          zeroDepreciation
          addons
          includedAddons
          sellingPoint
          claimDocs
          benefitsDescription
          descriptionDetail
          termCondition
          idv
          tenantId
          benefits {
            id
            parentId
            benefitCode
            sumInsured
            premium
            currency
            name
            description
          }
        }
      }
    }
    `
    return query(outputSchema, data);
  }

  getCarInsuranceFee({
    langId,
    type,
    seat,
    goodsCap,
    carInfo,
    usePurpose,
    productIds
  }) {
    const data = {
      langId, type,
      productIds,
      car: {
        usePurpose,
        brand: "HX1",
        model: "HX1-DX7",
        firstRegistrationYear: 2017, seat,
        licensePlate: "72A-004.88",
        currency: "VND",
        carInfo
      }
    };
    if (goodsCap) {
      data.car.goodsCap = goodsCap
      // data.car.seat = 0
    }
    const outputSchema = `
    query getCarInsuranceFee($productIds: [Int]!, $langId: String!, $type: String, $car: CarInfo!) {
      getCarInsuranceFee(productIds: $productIds, langId: $langId, type: $type, car: $car) {
        premiums
        car{
          carValueForReference
        }
        products{
          productCode
          premium
          listBenefit
          benefits{
            benefitCode
            premium
            sumInsured
          }
        }
      }
    }
    `
    return query(outputSchema, data);
  }

  getContractsInfo(data) {
    const variables = {
      // filter: JSON.stringify({
      //   externalData: { userId: data.userId },
      //   status: data.contractType === 'unpaid' ? 'new' : ['waiting_for_approve', 'cancelled', 'approved'].join(),
      //   langId: data.langId || 'vi'
      // })
      userId: data.userId,
      status: data.contractType === 'unpaid' ? 'new' : ['waiting_for_approve', 'cancelled', 'approved'].join(),
      langId: data.langId || 'vi'
    };
    const outputSchema = `query getPolicyDetails($userId: String!, $status: String!, $langId: String!) {
      getPolicyDetails(
        userId: $userId,
        status: $status,
        langId: $langId
      ) {
        id
        advanceCash
        approvedDate
        billingType
        bindingStatus
        bindingTerm
        cashlessGarage
        code
        companyLogo
        companyTranslations {
          langId
          name
        }
        quotationCode
        discountRate
        effective_date
        endorsement {
          code
          status
          IMExpiryDate
        }
        expired_date
        holderAddress
        holderCityProvince
        holderCityProvinceNameWithType
        holderCityProvinceType
        holderDistrict
        holderDistrictNameWithType
        holderDistrictType
        holderDob
        holderEmail
        holderName
        holderNationalId
        holderPhoneNumber
        holderWard
        holderWardNameWithType
        holderWardType
        id
        insuredDeclaredValue
        insuredMemberDetail {
          address
          benefit {
            benefitName
            sumAssured
          }
          brand
          certificate_link
          chassisNumber
          cityProvince
          cityProvinceNameWithType
          cityProvinceType
          district
          districtNameWithType
          districtType
          dob
          effective_date
          email
          engineNumber
          expired_date
          firstRegistrationYear
          manufactorYear
          model
          name
          nationalId
          phone
          planName
          plateNumber
          premium
          productName
          purposeOfVehicle
          refCarValue
          relationship
          releaseYear
          seatNumber
          vehicleOwnerName
          ward
          wardNameWithType
          wardType
        }
        nextBillingDate
        numberOfIM
        parnerPolicyCode
        premium
        productCode
        productLogo
        productName
        productType
        productTranslations {
          benefitsDescription
          claimDocs
          description
          descriptionDetail
          langId
          name
          sellingPoint
          termCondition
        }
        quotationCode
        quotationCreatedDate
        recipient {
          address
          cityProvince
          cityProvinceNameWithType
          cityProvinceType
          district
          districtNameWithType
          districtType
          email
          name
          phone
          typeDelivery
          ward
          wardNameWithType
          wardType
        }
        status
        zeroDepClaims
        zeroDepreciation
      }
    }`;
    return query(outputSchema, variables);
  }

  createAccidentInsurance(data) {
    const variables = {
      ...data,
      apiKey: API_KEY,
    }

    const outputSchema = `mutation createPolicyByType(
      $policyHolder: PolicyHolderInput
      $insuredMember: [InsuredMemberInput]
      $insuredMemberDetail: IsuredMemberDetail
      $selectedBenefitCodes: [String]
      $apiKey: String
    ) {
      createPolicyByType(
        policyHolder: $policyHolder
        insuredMember: $insuredMember
        insuredMemberDetail: $insuredMemberDetail
        selectedBenefitCodes: $selectedBenefitCodes
        apiKey: $apiKey
      ) {
        id
        quotation_code
      }
    }
    `;
    return mutate(outputSchema, variables);
  }

  createMotobikeInsurance(data) {
    const outputSchema = `mutation createMotobikeInsurance(
      $product: ProductInput
      $carOwner: OwnerInput
      $contractOwner: OwnerInput
      $car: CarInput
      $carDriver: CarDriverInput
      $recipient: RecipientInput
      $apiKey: String
      $isSendZNSNotify: Boolean
    ) {
      createPolicy(
        product: $product
        carOwner: $carOwner
        contractOwner: $contractOwner
        car: $car
        carDriver: $carDriver
        recipient: $recipient
        apiKey: $apiKey
        isSendZNSNotify: $isSendZNSNotify
      ) {
        id
        quotation_code
        phone
      }
    }`;
    return mutate(outputSchema, data);
  }

  createCarInsurance(data) {
    const outputSchema = `mutation createCarInsurance(
      $product: ProductInput
      $carOwner: OwnerInput
      $contractOwner: OwnerInput
      $car: CarInput
      $carDriver: CarDriverInput
      $recipient: RecipientInput
      $apiKey: String
      $isSendZNSNotify: Boolean
    ) {
      createPolicy(
        product: $product
        carOwner: $carOwner
        contractOwner: $contractOwner
        car: $car
        carDriver: $carDriver
        recipient: $recipient
        apiKey: $apiKey
        isSendZNSNotify: $isSendZNSNotify
      ) {
        id
        quotation_code
        phone
      }
    }`;
    return mutate(outputSchema, data);
  }

  createHomeInsurance(data) {
    const outputSchema = `mutation createHomeInsurance(
      $product: ProductInput
      $homeOwner: OwnerInput
      $contractOwner: OwnerInput
      $home: HomeInput
      $recipient: RecipientInput
      $seller: SellerInfo
      $apiKey: String
    ) {
      createPolicyHome(
        product: $product
        homeOwner: $homeOwner
        contractOwner: $contractOwner
        home: $home
        recipient: $recipient
        seller: $seller
        apiKey: $apiKey
      ) {
        id
        quotation_code
        phone
      }
    }`;
    return mutate(outputSchema, data);
  }

  getPersonalAccidentInsuranceDetail({ planIds, langId }) {
    const data = {
      planIds: [planIds],
      langId,
    };
    const outputSchema = `query getHealthInsuranceDetail(
      $planIds: [String]!
      $langId: String!
    ) {
      getHealthInsuranceDetail(planIds: $planIds, langId: $langId) {
        advanceCash
        benefits {
          apply_unit
          apply_type
          benefitCode
          childBenefits {
            code
            name
            sumAssured
          }
          createdAt
          currency
          data
          description
          id
          isActive
          isDelete
          level
          max_sum_assured
          min_sum_assured
          parentId
          rate {
            billing_type_id
            rate
            fixed_premium
            max_age
            min_age
          }
          rate_type
          requiredBenefit
          sumAssured
          type
          updatedAt
        }
        billingTypes {
          id
          plan_id
          billing_type
        }
        paymentTerms {
          id
          plan_id
          payment_term
        }
        branch_id
        cashlessGarage
        company {
          IsShowPreviousInsurer
          code
          id
          image
          isActive
          isDelete
          translation {
            address
            companyId
            createdAt
            description
            id
            langId
            phoneNumber
            updatedAt
          }
          type
        }
        companyId
        createdAt
        discountRate
        effectiveDate
        eligibility {
          id
          max_age
          max_insured_member
          min_age
          min_insured_member
          min_premiums
          product_id
          tenant_id
          updated_at
        }
        id
        image
        insuredDeclaredValue
        isActive
        isDelete
        listBenefit
        plan {
          created_by
          created_at
          description
          excludes {
            worldwide
          }
          geographicalCoverages {
            countries
            countries
            worldwide
          }
          id
          language
          name
          product_plan_id
          tenant_id
          updated_at
        }
        productCode
        translation {
          benefitsDescription
          claimDocs
          createdAt
          description
          descriptionDetail
          id
          langId
          name
          productId
          sellingPoint
          termCondition
          updatedAt
        }
        type
        updatedAt
        uwQuestions {
          id
          product_id
          question
          sequence
          tenant_id
          type
        }
        zeroDepClaims
        zeroDepreciation
      }
    }`;
    return query(outputSchema, data)
  }

  getMotobikeInsuranceDetail({ productId, langId }) {
    const data = {
      productId: productId,
      langId: langId,
    }
    const outputSchema = `query getMotobikeInsuranceDetail(
      $productId: String!
      $langId: String!
    ) {
      getMotobikeInsuranceDetail(productId: $productId, langId: $langId) {
        advanceCash
        benefits {
          apply_type
          apply_unit
          benefitCode
          sumInsured
          childBenefits {
            code
            name
            sumInsured
          }
          currency
          data
          description
          id
          isActive
          isDelete
          level
          max_sum_assured
          min_sum_assured
          name
          parentId
          requiredBenefit
          rate {
            id
            benefit_id
            premiumRule {
              seat_max
              seat_min
              age_max
              age_min
              id
              premium_value
            }
            vat
          }
        }
        branch_id
        cashlessGarage
        company {
          IsShowPreviousInsurer
          code
          id
          image
          isActive
          isDelete
          translation {
            address
            companyId
            createdAt
            description
            id
            langId
            name
            phoneNumber
            updatedAt
          }
          type
        }
        companyId
        createdAt
        discountRate
        effectiveDate
        garage {
          id
          tax_code
        }
        id
        image
        insuredDeclaredValue
        isActive
        isDelete
        listBenefit
        plan {
          created_at
          created_by
          description
          geographicalCoverages {
            continents
            countries
            worldwide
          }
          id
          language
          name
          product_plan_id
          tenant_id
          updated_at
        }
        productCode
        tenantId
        translation {
          benefitsDescription
          claimDocs
          createdAt
          description
          descriptionDetail
          id
          langId
          name
          productId
          sellingPoint
          termCondition
          updatedAt
        }
        type
        updatedAt
        zeroDepClaims
        zeroDepreciation
      }
    }`;
    return query(outputSchema, data);
  }

  getHomeInsuranceDetail({ productId, langId }) {
    const data = {
      productId: productId,
      langId: langId,
    }
    const outputSchema = `query getHomeInsuranceDetail(
      $productId: String!
      $langId: String!
    ) {
      getHomeInsuranceDetail(productId: $productId, langId: $langId) {
        advanceCash
        benefits {
          apply_type
          apply_unit
          benefitCode
          sumInsured
          childBenefits {
            code
            name
            sumInsured
          }
          currency
          data
          description
          id
          isActive
          isDelete
          level
          max_sum_assured
          min_sum_assured
          name
          parentId
          requiredBenefit
          rate {
            id
            benefit_id
            premiumRule {
              id
              premium_formula
              age_max
              age_min
            }
            vat
          }
        }
        branch_id
        cashlessGarage
        company {
          IsShowPreviousInsurer
          code
          id
          image
          isActive
          isDelete
          translation {
            address
            companyId
            createdAt
            description
            id
            langId
            name
            phoneNumber
            updatedAt
          }
          type
        }
        companyId
        createdAt
        discountRate
        effectiveDate
        garage {
          id
          tax_code
        }
        id
        image
        insuredDeclaredValue
        isActive
        isDelete
        listBenefit
        plan {
          created_at
          created_by
          description
          geographicalCoverages {
            continents
            countries
            worldwide
          }
          id
          language
          name
          product_plan_id
          tenant_id
          updated_at
        }
        productCode
        tenantId
        translation {
          benefitsDescription
          claimDocs
          createdAt
          description
          descriptionDetail
          id
          langId
          name
          productId
          sellingPoint
          termCondition
          updatedAt
        }
        type
        updatedAt
        zeroDepClaims
        zeroDepreciation
      }
    }`;
    return query(outputSchema, data);
  }

  async verifyUser({ muid, maccesstoken }) {
    console.log('verify user');
    const data = { muid, maccesstoken };
    const outputSchema = `query verifyUser($muid: String!, $maccesstoken: String!) {
      verifyUser(muid: $muid, maccesstoken: $maccesstoken) {
        returncode
        returnmessage
      }
    }`;

    const response = await query(outputSchema, data);
    if (response.error) {
      return {
        returncode: -1,
      }
    }

    return response.data.verifyUser;
  }


  getCities() {
    const data = {
      countryCode: "VN",
    };

    const outputSchema = `query getCities($countryCode: String!) {
      getCities( countryCode: $countryCode ) {
        code
        name
        slug
        type
        nameWithType
        path
        pathWithType
        parentCode
        status
      }
    }`;
    return query(outputSchema, data);
  }

  getDistricts({ city }) {
    const data = {
      countryCode: "VN",
      cityCode: city,
    };
    const outputSchema = `query getDistricts(
      $countryCode: String!
      $cityCode: String!
    ) {
      getDistricts( countryCode: $countryCode, cityCode: $cityCode ) {
        code
        name
        slug
        type
        nameWithType
        path
        pathWithType
        parentCode
        status
      }
    }`
    return query(outputSchema, data);
  }
  getWards({ city, district }) {
    const data = {
      countryCode: "VN",
      cityCode: city,
      districtCode: district,
    };
    const outputSchema = `query getWards(
      $countryCode: String!
      $cityCode: String!
      $districtCode: String!
    ) {
      getWards( countryCode: $countryCode, cityCode: $cityCode, districtCode: $districtCode) {
        code
        name
        slug
        type
        nameWithType
        path
        pathWithType
        parentCode
      }
    }`;
    return query(outputSchema, data);
  }

  payOrder(contractId) {
    const data = {
      policyId: contractId
    }
    const outputSchema = `query createOrder($policyId: String!){
      createOrder(policyId:$policyId){
      orderUrl
    zpTransToken
    message
      }
    }`
    return query(outputSchema, data);
  }

  // agreementPay(user_id, quotation_code, binding_type, binding_term) {
  //   const data = {
  //     user_id,
  //     quotation_code,
  //     binding_type,
  //     binding_term,
  //   };
  //   return this.request("/insurance/create-agreement", "POST", data);
  // }

  async agreementPay(userId, quotationCode, bindingType, bindingTerm) {
    const data = {
      userId,
      quotationCode,
      bindingType,
      bindingTerm,
    };

    const outputSchema = `query requestBinding(
      $userId: String!,
      $quotationCode: String!,
      $bindingType: BindingType!,
      $bindingTerm: Int,
      $maxAmount: Float
    ) {
      requestBinding(
        userId: $userId,
        quotationCode: $quotationCode,
        bindingType: $bindingType,
        bindingTerm: $bindingTerm,
        maxAmount: $maxAmount
      ) {
        success
        message
        bindingToken
        bindingUrl
        deepLink
        bindingQrLink
        shortLink
      }
    }`

    const res = await query(outputSchema, data);
    if (res.error) {
      throw new Error();
    }

    return res;
  }

  getContractDetail({ mUid, quotationCode, mode, langId = 'vi' }) {
    const variables = {
      externalData: { userId: mUid, langId },
      quotationCode,
      mode: mode
    }
    const outputSchema = `query getPolicyByQuotationCode($externalData: JSON!, $quotationCode: String!, $mode: String) {
      getPolicyByQuotationCode(
        externalData: $externalData,
        quotationCode: $quotationCode,
        mode: $mode
      ) {
        id
        advanceCash
        approvedDate
        billingType
        bindingStatus
        bindingTerm
        cashlessGarage
        code
        companyCode
        companyLogo
        companyTranslations {
          langId
          name
        }
        quotationCode
        discountRate
        effective_date
        endorsement {
          code
          status
          IMExpiryDate
          partnerEndorsementCode
        }
        expired_date
        holderAddress
        holderCityProvince
        holderCityProvinceNameWithType
        holderCityProvinceType
        holderDistrict
        holderDistrictNameWithType
        holderDistrictType
        holderDob
        holderEmail
        holderName
        holderNationalId
        holderPhoneNumber
        holderWard
        holderWardNameWithType
        holderWardType
        id
        insuredDeclaredValue
        insuredMemberDetail {
          address
          benefit {
            benefitName
            sumAssured
          }
          brand
          certificate_link
          chassisNumber
          cityProvince
          cityProvinceNameWithType
          cityProvinceType
          district
          districtNameWithType
          districtType
          dob
          effective_date
          email
          engineNumber
          expired_date
          firstRegistrationYear
          manufactorYear
          model
          name
          nationalId
          phone
          planName
          plateNumber
          premium
          productName
          purposeOfVehicle
          refCarValue
          relationship
          releaseYear
          seatNumber
          vehicleOwnerName
          ward
          wardNameWithType
          wardType
        }
        nextBillingDate
        numberOfIM
        parnerPolicyCode
        premium
        productId
        productCode
        productLogo
        productName
        productType
        productTranslations {
          benefitsDescription
          claimDocs
          description
          descriptionDetail
          langId
          name
          sellingPoint
          termCondition
        }
        quotationCode
        quotationCreatedDate
        recipient {
          address
          cityProvince
          cityProvinceNameWithType
          cityProvinceType
          district
          districtNameWithType
          districtType
          email
          name
          phone
          typeDelivery
          ward
          wardNameWithType
          wardType
        }
        holderDetail {
          id,
          person {
            address {
              district_code
              region_code
              ward_code
              street_address
            }
            dob
            email
            external_data {
              userId
            }
            name
            phone
          }
        }
        benefitDetail {
          id
          code
        }
        carInfoDetail {
          car_info,
          goods_cap,
          use_type,
          seat
        }
        status
        zeroDepClaims
        zeroDepreciation
      }
    }`;
    return query(outputSchema, variables);
  }

  getInsuranceHomeEmbed({ phoneNumber, productCode }) {
    const variables = { phoneNumber, productCode }
    const outputSchema = `query getInsuranceHomeEmbed($phoneNumber: String!, $productCode: [String]!) {
      getInsuranceHomeEmbed(
        phoneNumber: $phoneNumber,
        productCode: $productCode
      ) {
        quotationCode,
        effectiveDate,
        expiryDate,
        name,
        amountInsurance,
        nameProduct,
        imageCompany,
        status,
        muid
      }
    }`;
    return query(outputSchema, variables);
  }

  getUserInfo({ oauthCode, verifierCode }) {
    const variables = {
      oAuthCode: oauthCode,
      verifierCode: verifierCode,
    }
    const outputSchema = `query getUserInfo($oAuthCode: String!, $verifierCode: String!) {
      getUserInfo(
        oAuthCode: $oAuthCode,
        verifierCode: $verifierCode
      ) {
        context_id
        trace_id
        data {
          muid
          user_phone
          user_name
          user_email
          user_identity_info {
            birthday
            gender
            full_name
            permanent_address
          }
          user_identity_image {
            id_number
            id_type
            issue_date
            issue_place
            expiration_date
            identity_image_font
            identity_image_back
          }
        }
      }
    }`

    return query(outputSchema, variables);
  }

  getBrandsTasco() {
    const outputSchema = `query getCarBrandsAndModelTasco {
      getCarBrandsAndModelTasco {
        code
        name
        logo
        models {
          code
          name
        }
      }
    }`
    return query(outputSchema);
  }

  getBrandsMIC() {
    const outputSchema = `query getBrandMIC {
      getCarBrandsMIC
    }`
    return query(outputSchema);
  }

  getModelsMIC({ brand }) {
    const variables = {
      brand: brand
    }
    const outputSchema = `query getCarModelsMIC($brand: String!) {
      getCarModelsMIC(brand: $brand)
    }`
    return query(outputSchema, variables);
  }

  getBrandsBSH() {
    const outputSchema = `query getBrandBSH {
      getCarBrandsBSH
    }`
    return query(outputSchema);
  }

  getModelsBSH({ brand }) {
    const variables = {
      brand: brand
    }
    const outputSchema = `query getCarModelsBSH($brand: String!) {
      getCarModelsBSH(brand: $brand) {
        Hang
        Ma
      }
    }`
    return query(outputSchema, variables);
  }

  getListBrandModelCarByCompany({ companyCode, brand }) {
    const variables = {
      companyCode,
      brand
    };
    const outputSchema = `query getListBrandModelCarByCompany($companyCode: String!, $brand: String) {
      getListBrandModelCarByCompany(companyCode: $companyCode, brand: $brand) {
        companyCode
        carBrand {
          id
          name
          key
        }
        carModel {
          id
          name
          key 
        }
      }
    }`;
    return query(outputSchema, variables);
  }

  getCompanies({ langId }) {
    const variables = {
      langId: langId
    }
    const outputSchema = `query getCompanies($langId: String!) {
      getCompanies(langId: $langId) {
        code
        name
        id
      }
    }`
    return query(outputSchema, variables);
  }

  createPolicyDraft(data) {
    const outputSchema = `mutation createPolicyDraft(
      $tenantId: String,
      $branchId: String,
      $productCode: String,
      $productId: Int,
      $effectiveDate: String,
      $expiryDate: String,
      $benefits: [PolicyDraftBenefitInput],
      $contractOwner: PolicyDraftContractOwnerInput
      $car: PolicyDraftCarInput
    ) {
      createPolicyDraft(
        tenantId: $tenantId
        branchId: $branchId
        productCode: $productCode
        productId: $productId
        effectiveDate: $effectiveDate
        expiryDate: $expiryDate
        benefits: $benefits
        contractOwner: $contractOwner
        car: $car
      ){
        success
      }
    }`;
    return mutate(outputSchema, data);
  }

  getFireExplosionInsuranceAllProduct({ langId, type }) {
    const data = {
      langId,
      type,
      apiKey: API_KEY,
    };
    const outputSchema = `
    query getFireExplosionInsuranceAllProduct($langId: String!, $type: Int, $apiKey: String!) {
      getFireExplosionInsuranceAllProduct(
        langId: $langId
        type: $type
        apiKey: $apiKey
      )  {
        products {
          id
          productCode
          advanceCash
          benefits {
            apply_type
            apply_unit
            benefitCode
            sumInsured
            childBenefits {
              code
              name
              sumInsured
            }
            data
            description
            id
            isActive
            isDelete
            level
            max_sum_assured
            min_sum_assured
            name
            parentId
            requiredBenefit
            rate {
              id
              benefit_id
              premiumRule {
                id
                premium_formula
                age_max
                age_min
              }
              vat
            }
          }
          benefitsDescription
          billingType
          claimDocs
          company{
            code
            description
            id
            image
            name
          }
          description
          descriptionDetail
          discountRate
          effectiveDate
          insuredDeclaredValue
          name
          planId
          productId
          sellingPoint
          totalAllPremium
          totalAllSumAssured
          type
          zeroDepClaims
        }
      }
    }
    `
    return query(outputSchema, data)
  }

  getPviPropertyAllRisksCategories({ parentValue } = {}) {
    const variables = {
      parentValue
    }
    const outputSchema = `query getPviPropertyAllRisksCategories($parentValue: String) {
      getPviPropertyAllRisksCategories(parentValue: $parentValue) {
        Disabled
        Group
        Selected
        Text
        Value
      }
    }`
    return query(outputSchema, variables);
  }
}

const AppApiInstance = new AppApi();

export { AppApiInstance };
